import { Typography } from "antd";
import React from "react";
import { formatNumber } from "../../../utils/functions/formatNumber";

const { Title, Paragraph } = Typography;

export default function CardData({ data, subtitle, date, lang }) {
  return (
    <div className="card-data">
      <Title
        level={1}
        style={{
          color: "var(--blue-primary)",
          marginBottom: "0px",
          fontSize: "30px",
        }}
      >
        {data ? formatNumber(data, lang) : "--"}
      </Title>
      <Paragraph
        className="gbi"
        style={{
          fontSize: "14px",
          marginBottom: "0px",
        }}
      >
        {subtitle}
      </Paragraph>
      <div className="date_info">{date}</div>
    </div>
  );
}
